import { type Extendable } from '@/types/props';

const Column = ({ children, className }: Extendable) => {
  return <div className={`flex flex-col gap-2 ${className}`}>{children}</div>;
};

export { Column };
